export interface IApiGCloudGameItem {
  readonly id: number;
  readonly gameId: number;
  readonly downloadUser: string;
  readonly downloadTime: string;
  readonly gcloudVersion: string;
  readonly sdkList: readonly IGCloudSdkItem[];
  readonly gameName: string;
  readonly gameCreateUser: string;
  readonly memberList: readonly IGCloudMemberItem[];
  readonly isBindKpiCode: boolean;
}

export interface IAPIGameSdkVersionOption {
  readonly gameIdList: number[];
  readonly gcloudVersionList: string[];
  readonly sdkList: IAPSdkVersionOption[];
}

export interface IAPSdkVersionOption {
  sdkName: string;
  sdkVersionList: {
    sdkVersion: string;
    gcloudVersionList: string[];
  }[];
}

export interface IApiNoticeListRes {
  readonly noticeList: readonly IApiNoticeInfo[];
  readonly gameApprovalList: readonly IApiNoticeApprovalInfo[];
}

export interface IApiNoticeCreateRes {
  readonly createRes: { insertId: number };
}

export interface IGCloudSdkItem {
  sdkName: string;
  sdkVersion: string;
}

export interface IGCloudMemberItem {
  userId: string;
  roleId: GCloudMemberRole;
  email: string;
  isOaUser: boolean;
}

export enum GCloudMemberRole {
  Admin,
  Common,
}

export enum NoticeSystemStatus {
  Default = '',
  PendingUpdate = 1, // 待修改
  PendingApproval = 2, // 待审批
  Draft = 3, // 草稿
  PendingPublic = 4, // 待发布
  Published = 5, // 已发布
}

export enum NoticeSystemBusiness {
  GCloud = 'gcloud',
  InGame = 'ingame',
}

export interface IApiNoticeInfo {
  readonly id: number;
  readonly Business: NoticeSystemBusiness;

  // default NoticeSystemStatus.Default
  readonly Status: NoticeSystemStatus;

  readonly Title: string;
  readonly Founder: string; // email

  // project search condition, save db, json object string{type[game id|gcloud版本|组件版本],condition[过滤条件object]}
  // db returns json
  readonly ScopeCondition: {
    readonly type: string;
    readonly condition: Object;
  };

  // search result list, save to db json array string[{...fronted custom format}]
  // db returns json
  readonly ScopeResult: ReadonlyArray<INoticeSystemScopeResult>;
  readonly ScopeResultNotSelected: ReadonlyArray<INoticeSystemScopeResult>;
  // mail content, html string
  readonly MailContent: string;

  // 0->disabled, 1->enabled, default 0
  readonly MyOAEnable: NoticeSystemEnable;
  readonly ReasonReject: string;
  // admin reject reason. only status (pendingUpdate) valid

  readonly CreateTime: Date;
  readonly ModifyTime: Date;
}

export interface IApiNoticeItem extends IApiNoticeInfo {
  readonly approvalId?: number;
  readonly GameID?: string;
  readonly MyOAStatus?: NoticeSystemGameApprovalMyOAStatus;
  readonly MyOAApprovedMembers?: string;
}

export interface IApiMyoaWorkItem {
  readonly create_time: string;
  readonly expired_time_ms: number;
  readonly process_inst_id: string;
  readonly status: MyOAWorkItemStatus;
}

export enum MyOAWorkItemStatus {
  PendingApproval = 100, // 待审批
  Approved = 200, // 已审批&我的申请
  Closed = 300, // 关闭
  OpClosed = 301, // 运维关闭
  MarkedProcessed = 302, // 标记为已处理
  Abnormal = 303, // 异常
  Abandoned = 400, // 废弃
}

export interface IApiAddNoticeBody {
  business: NoticeSystemBusiness;
  title: string;
  scopeCondition: { type: string; condition: Object };
  scopeResult: ReadonlyArray<INoticeSystemScopeResult>;
  scopeResultNotSelected: ReadonlyArray<INoticeSystemScopeResult>;
  mailContent: string;
  myOAEnable: NoticeSystemEnable;
  isDraft: boolean;
}

export interface IApiUpdateNoticeBody {
  id: number;
  title: string;
  scopeCondition: { type: string; condition: Object };
  scopeResult: ReadonlyArray<INoticeSystemScopeResult>;
  scopeResultNotSelected: ReadonlyArray<INoticeSystemScopeResult>;
  mailContent: string;
  myOAEnable: NoticeSystemEnable;
  isDraft: boolean;
}

export interface IQuerySdkBody {
  page?: number;
  pageSize?: number;
  operator: string;
  gameIdStr?: string;
  gcloudVersionStr?: string;
  sdkVersionList?: IGCloudSdkItem[];
}

export interface INoticeSystemScopeResult {
  readonly gameID: string;

  // save game name, reduce gcloud api mapping
  // name change is small
  readonly gameName: string;

  readonly downloadUser: string;

  // game all members
  readonly members: ReadonlyArray<string>;

  // need myoa approval members
  // allow role: admin/xxxx
  readonly adminMembers: ReadonlyArray<string>;
  readonly sdkList: {
    sdkName: string;
    sdkVersion: string;
    gcloudVersion: string;
  }[];

  readonly isBindKpiCode: boolean;
  // storing more fields..
  // readonly [...extension]: any
}

export enum NoticeSystemEnable {
  Disable = 0,
  Enable = 1,
}

export enum NoticeSystemGameApprovalMyOAStatus {
  Unread,
  Read,
}

export interface IApiNoticeApprovalInfo {
  readonly id: number;

  // relation notice system table id<INoticeSystemModel.id>
  readonly NoticeSystemID: number;

  readonly GameID: string;

  // quick status
  // have you read it?, 0->unread, 1->read
  readonly MyOAStatus: NoticeSystemGameApprovalMyOAStatus;

  // myoa approved done. multiple members(,)split
  readonly MyOAApprovedMembers: string;

  readonly CreateTime: Date;
  readonly ModifyTime: Date;
}
